export default "__VITE_ASSET__BKP1yL$V__"